import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import "react";
const SvgFacebook = (props)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 21,
        height: 21,
        fill: "none",
        viewBox: "0 0 21 21",
        ...props,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("g", {
                clipPath: "url(#facebook_svg__a)",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    clipPath: "url(#facebook_svg__b)",
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: "#0866FF",
                            d: "M20.5 10.905c0-5.523-4.477-10-10-10s-10 4.477-10 10c0 4.69 3.229 8.625 7.584 9.706v-6.65H6.022v-3.056h2.062V9.588c0-3.404 1.54-4.982 4.882-4.982.634 0 1.727.125 2.174.249v2.77a13 13 0 0 0-1.155-.037c-1.64 0-2.273.621-2.273 2.236v1.08h3.266l-.561 3.057h-2.705v6.871c4.951-.598 8.788-4.814 8.788-9.927"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: "#fff",
                            d: "m14.417 13.96.561-3.056h-3.266V9.823c0-1.615.633-2.236 2.273-2.236.51 0 .92.012 1.155.037v-2.77c-.447-.125-1.54-.249-2.174-.249-3.341 0-4.882 1.578-4.882 4.982v1.317H6.022v3.056h2.062v6.65a10 10 0 0 0 3.627.221V13.96z"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("clipPath", {
                        id: "facebook_svg__a",
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: "#fff",
                            d: "M.5.904h20v20H.5z"
                        })
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("clipPath", {
                        id: "facebook_svg__b",
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            fill: "#fff",
                            d: "M.5.904h20v20H.5z"
                        })
                    })
                ]
            })
        ]
    });
const facebook = SvgFacebook;
export { facebook as default };
